module.exports = {

  getNextLink: function (link) {
    return this.client.get(link)
  },

  getSelf: function () {
    return this.client.get(`/v${this.v}/user/self/`)
  },

  getBatchOfUsers: function (commaSeparatedUserIds) {
    return this.client.get(`/v${this.v}/user/`, {
      params: {
        self: commaSeparatedUserIds,
      },
    })
  },

  getFriends: function (userId, offset = 0, limit) {
    return this.client.get(`/v${this.v}/user/`, {
      params: {
        friends_with: userId,
        limit: limit,
        status: 'active',
        offset: offset,
      },
    })
  },

  getFriendRequests: function (userId) {
    return this.client.get(`/v${this.v}/user/`, {
      params: {
        requested_friendship_with: userId,
      },
    })
  },

  removeFriend: function (userId, userToUnfriendId) {
    return this.client.delete(`/v${this.v}/friendship/${userToUnfriendId}_${userId}/`)
  },

  acceptFriend: function (userId, userToAcceptId) {
    return this.client.patch(`/v${this.v}/friendship/${userToAcceptId}_${userId}/`, {
      status: 'active',
    })
  },

  getPendingFriendRequests: function (userId) {
    return this.client.get(`/v${this.v}/friendship/`, {
      params: {
        from_user: userId,
        status: 'pending',
      },
    })
  },

  getSuggestedFriends: function (userId, offset = 0) {
    return this.client.get(`/v${this.v}/user/`, {
      params: {
        suggested_friends_for: userId,
        suggested_friends_source: 'mmf',
        limit: 10,
        offset: offset,
      },
    })
  },

  addFriend: function (friendId, userId) {
    return this.client.post(`/v${this.v}/friendship/`, {
      _links: {
        to_user: [{
          href: `/v${this.v}/user/${friendId}/`,
          id: `${friendId}`,
        }],
        from_user: [{
          'href': `/v${this.v}/user/${userId}/`,
          'id': `${userId}`,
        }],
      },
    })
  },

  searchUsers: function (searchTerm) {
    return this.client.get(`/v${this.v}/user/`, {
      params: {
        q: searchTerm,
      },
    })
  },

  updateUser: function (userId, data) {
    return this.client.put(`/v${this.v}/user/${userId}/`, data)
  },

  postUser: function (user) {
    const data = {
      first_name: user.firstName,
      last_name: user.lastName,
      email: user.email,
      password: user.password,
      birthdate: user.birthdate,
      gender: user.gender,
      location: user.location,
      consent_matrix_version: user.consent_matrix_version,
      consents: user.consents,
      gdpr_iso_code: user.gdpr_iso_code,
    }

    // support onboarding from other verticals
    if (user.uacfId) { data.uacf_id = user.uacfId }
    return this.client.post(`/v${this.v}/user/?sso=True`, data)
  },

  postPromotionalPreference: function (options, config) {
    const data = {
      privacy_standard: options.privacyStandard,
      region: options.region,
      preference_type: 'ua-marketing-opt-in',
      choice: options.choice,
      _links: {
        user: [{
          id: options.userId.toString(),
          href: `/v${this.v}/user/${options.userId}/`,
        }],
      },
    }

    return this.client.post(`/v${this.v}/promotional_preference/`, data, config)
  },

  deactivateUser: function (user) {
    const data = {
      user_href: `/v${this.v}/user/${user.id}/`,
      reason_code: 'other',
      password: user.password,
    }
    return this.client.post(`/v${this.v}/user_deactivation/`, data)
  },

}



// WEBPACK FOOTER //
// ./shared/mapmy/users.js